export default __webpack_public_path__ + "static/media/nex-logo.f7b559e5.svg";